import * as styles from 'styles/pages/Styleguide.css'
import Anchor from 'components/atoms/navigation/Anchor'
import SGBlocks from 'components/utils/styleguide/SGBlocks'
import SGButtons from 'components/utils/styleguide/SGButtons'
import SGCharts from 'components/utils/styleguide/SGCharts'
import SGInputs from 'components/utils/styleguide/SGInputs'
import SGIcons from 'components/utils/styleguide/SGIcons'
import SGBalloons from 'components/utils/styleguide/SGBalloons'
import SGTooltips from 'components/utils/styleguide/SGTooltips'
import { SGAvatar } from 'components/utils/styleguide/SGAvatar'

const SGAtoms = () => (
  <Anchor placement='atoms'>

    <Anchor placement='atoms_avatar'>
      <h2 className={ styles.sgHeading }>Avatar</h2>
      <SGAvatar />
    </Anchor>

    <Anchor placement='atoms_blocks'>
      <h2 className={ styles.sgHeading }>Blocks</h2>
      <SGBlocks />
    </Anchor>

    <Anchor placement='atoms_tooltips'>
      <h2 className={ styles.sgHeading }>Tooltips</h2>
      <SGTooltips />
    </Anchor>

    <Anchor placement='atoms_buttons'>
      <h2 className={ styles.sgHeading }>Buttons</h2>
      <SGButtons />
    </Anchor>

    <Anchor placement='atoms_inputs'>
      <h2 className={ styles.sgHeading }>Inputs</h2>
      <SGInputs />
    </Anchor>

    <Anchor placement='atoms_icons'>
      <h2 className={ styles.sgHeading }>Icons</h2>
      <SGIcons />
    </Anchor>

    <Anchor placement='atoms_charts'>
      <h2 className={ styles.sgHeading }>Charts</h2>
      <SGCharts />
    </Anchor>

    <Anchor placement='atoms_balloons'>
      <h2 className={ styles.sgHeading }>Balloons</h2>
      <SGBalloons />
    </Anchor>

  </Anchor>
)


export default SGAtoms
